import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Title from '../miscellaneous/Title';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import {useStyles} from "../miscellaneous/constants";




const myStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "space-between"
    },
    icon: {
        position: "absolute",
        right: "10"
    },
    tooltip: {
        zIndex: 10,
        border: "1px solid lightgrey",
        backgroundColor: "white",

    },
    div: {
        padding: "5px"
    },
    name: {
        padding: "5px",
        color: "#8884d8",
        textAlign: "center",
        backgroundColor: "lightgrey"
    }
});



export default function SelectSolvers(props) {
    const classes = useStyles();


    return (
        <React.Fragment>
            <Title>Graphical Comparison between Two Solvers</Title>

            <Box textAlign="center" fontWeight="fontWeightLight"><Typography>Select two solvers</Typography></Box>
            <Box textAlign="center">
                <br/>
                <form onSubmit={e => props.selectGraphSolvers(e)} className={classes.versus} noValidate>
                    <div style={{'display': 'flex', "justifyContent": "center"}}>
                        <FormControl fontSize="h5.fontSize" style={{minWidth: '35%'}}  className={classes.formControl}>
                            <InputLabel htmlFor="solver1">Solver 1</InputLabel>
                            <Select required native inputProps={{name: 'solver1', id: 'solver1',}}>
                                <option aria-label="None" value=""/>
                                {props.solvers.map(s => <option key={"os1-" + s.id} value={s.id}>{s.name + " " + s.version}</option>)}
                            </Select>
                        </FormControl>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <FormControl className={classes.formControl} style={{minWidth: '35%'}}>
                            <InputLabel htmlFor="solver2">Solver 2</InputLabel>
                            <Select required native inputProps={{name: 'solver2', id: 'solver2',}}>
                                <option aria-label="None" value=""/>
                                {props.solvers.map(s => <option key={"os2-" + s.id} value={s.id}>{s.name + " " + s.version}</option>)}
                            </Select>
                        </FormControl>
                    </div>
                    <br/><br/>
                    <Button variant="outlined" color="primary" type="submit">
                        Compare !
                    </Button>
                </form>
            </Box>
        </React.Fragment>
    )

}